/* BELORA — SKIMS PURE · wishlist.

   SKIMS shows a heart in the header cluster, on every product card and on the
   PDP gallery. Leaving it out to avoid a dead control cost the header its
   silhouette, so it is built for real instead: the list lives in this browser,
   survives a reload, and every heart reports its state to assistive tech
   through aria-pressed.

   It is deliberately NOT presented as an account feature. Nothing here syncs
   between devices and nothing claims to, because nothing behind it does.

   Storage: one JSON array under `belora:wishlist`, each entry
   { handle, title, url, image, price }. Reads are defensive — a private window,
   cleared site data or a browser that blocks storage all end up as an empty
   list rather than an exception. */
(function () {
  'use strict';

  var KEY = 'belora:wishlist';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var v = raw ? JSON.parse(raw) : [];
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* storage blocked */ }
    document.documentElement.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: list } }));
  }

  function has(handle) {
    return read().some(function (i) { return i.handle === handle; });
  }

  function toggle(item) {
    var list = read();
    var at = -1;
    for (var i = 0; i < list.length; i++) if (list[i].handle === item.handle) { at = i; break; }
    if (at >= 0) list.splice(at, 1); else list.unshift(item);
    write(list);
    return at < 0;   // true when it was added
  }

  // Idempotent: adding what is already there leaves it there. "Move to
  // Wishlist" must never turn into "remove from wishlist" just because the
  // shopper had already saved the item, which toggle() would do.
  function add(item) {
    if (!item || !item.handle) return false;
    var list = read();
    for (var i = 0; i < list.length; i++) if (list[i].handle === item.handle) { write(list); return true; }
    list.unshift(item);
    write(list);
    return true;
  }

  function itemFrom(btn) {
    return {
      handle: btn.getAttribute('data-wishlist'),
      title: btn.getAttribute('data-wl-title') || '',
      url: btn.getAttribute('data-wl-url') || '',
      image: btn.getAttribute('data-wl-image') || '',
      price: btn.getAttribute('data-wl-price') || '',
    };
  }

  /* ---- hearts ---------------------------------------------------------- */

  function paint(btn) {
    var on = has(btn.getAttribute('data-wishlist'));
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('is-saved', on);
    var added = btn.getAttribute('data-wl-added');
    var removed = btn.getAttribute('data-wl-removed');
    if (added && removed) btn.setAttribute('aria-label', on ? removed : added);
  }

  function paintAll() {
    document.querySelectorAll('[data-wishlist]').forEach(paint);
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist]') : null;
    if (!btn) return;
    // A heart on a product card sits inside the card's own link.
    e.preventDefault();
    e.stopPropagation();
    toggle(itemFrom(btn));
    renderPanel();
    // After the panel, not before: renderPanel creates the remove buttons, and
    // they carry data-wishlist too. Painting first left them unpainted and
    // silent to assistive tech.
    paintAll();
  });

  /* ---- the panel ------------------------------------------------------- */

  function renderPanel() {
    var body = document.querySelector('[data-wishlist-body]');
    if (!body) return;
    var list = read();
    var empty = body.querySelector('[data-wishlist-empty]');
    var ul = body.querySelector('[data-wishlist-list]');
    if (!ul) return;
    if (empty) empty.hidden = list.length > 0;
    ul.hidden = list.length === 0;
    ul.textContent = '';
    list.forEach(function (i) {
      var li = document.createElement('li');
      li.className = 'sk-wl__row';
      var a = document.createElement('a');
      a.className = 'sk-wl__link';
      a.href = i.url || '#';
      if (i.image) {
        var img = document.createElement('img');
        img.className = 'sk-wl__img';
        img.src = i.image;
        img.alt = '';
        img.loading = 'lazy';
        a.appendChild(img);
      }
      var txt = document.createElement('span');
      txt.className = 'sk-wl__meta';
      var t = document.createElement('span');
      t.className = 'sk-wl__title';
      t.textContent = i.title;
      txt.appendChild(t);
      if (i.price) {
        var p = document.createElement('span');
        p.className = 'sk-wl__price';
        p.textContent = i.price;
        txt.appendChild(p);
      }
      a.appendChild(txt);
      li.appendChild(a);

      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'sk-wl__remove';
      rm.setAttribute('data-wishlist', i.handle);
      rm.setAttribute('data-wl-title', i.title);
      rm.setAttribute('data-wl-url', i.url);
      rm.setAttribute('data-wl-image', i.image);
      rm.setAttribute('data-wl-price', i.price);
      rm.textContent = body.getAttribute('data-remove-label') || 'Kaldır';
      li.appendChild(rm);
      ul.appendChild(li);
    });
  }

  function boot() { renderPanel(); paintAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Other tabs, and our own writes.
  window.addEventListener('storage', function (e) { if (e.key === KEY) boot(); });
  document.documentElement.addEventListener('wishlist:change', paintAll);

  window.BeloraWishlist = { read: read, has: has, toggle: toggle, add: add, refresh: boot };
})();
